import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function exportTestResultsToConexus(testKey) {
	return fetch(
		`${ENDPOINT_URL}/test/export/conexus`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				testKey,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
